import { FC } from "react";
import ModalPortal from "components-new/ModalPortal";
import { Button } from "components/shared";
import { BUTTON_COLORS, BUTTON_VARIANTS } from "components/shared/Button/Button";
import styles from "../UserRoles.module.sass";

interface SureModalProps {
	callback: () => void;
	close: () => void;
}

const SureModal: FC<SureModalProps> = ({ callback, close }) => {
	return (
		<ModalPortal handleClose={close} title="Снять права администратора?" outSide={false}>
			<p className={styles.modalText}>Продолжив вы потеряете права доступа</p>
			<div className="df">
				<Button full variant={BUTTON_VARIANTS.OUTLINED} onClick={close}>
					Отменить
				</Button>
				<Button full className={styles.btnModal} color={BUTTON_COLORS.ERROR} onClick={callback}>
					Продолжить
				</Button>
			</div>
		</ModalPortal>
	);
};

export default SureModal;
